import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavTab from 'components/nav-tab';
import { DRAFT_URL, FORUMS_URL, RULES_URL } from 'config';

class NavTabBar extends Component {
  render() {
    return (
      <nav className="tabs is-centered">
        <div className="container">
          <ul>
            <NavTab
              to="/matches"
              selectedPaths={['/matches']}
              title="Matches"
              iconClassName="fas fa-calendar-alt"
            />
            <NavTab
              to="/standings"
              selectedPaths={['/standings']}
              title="Standings"
              iconClassName="fas fa-sort-amount-up"
            />
            <NavTab
              to="/teams"
              selectedPaths={['/teams']}
              title="Teams"
              iconClassName="fas fa-shield-alt"
            />
            <NavTab
              to="/players"
              selectedPaths={['/players']}
              title="Stats"
              iconClassName="fas fa-user-shield"
            />
            <NavTab
              to={FORUMS_URL}
              title="Forums"
              iconClassName="fas fa-comments"
              target="_blank"
              external
            />
            <NavTab
              to={RULES_URL}
              title="Rules"
              iconClassName="fas fa-book"
              target="_blank"
              external
            />
            <NavTab
              to={DRAFT_URL}
              title="Draft"
              iconClassName="fas fa-table"
              target="_blank"
              external
            />
            <NavTab
              to="/history"
              selectedPaths={['/history']}
              title="History"
              iconClassName="fas fa-trophy"
            />
          </ul>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(NavTabBar);



// WEBPACK FOOTER //
// ./src/components/nav-tab-bar/nav-tab-bar.js